'use client';

import { Button, Spinner } from '@venienergygroup/shared-components';
import { useTranslations } from 'next-intl';
import { ComponentProps, FC, PropsWithChildren, ReactNode } from 'react';

type LoginProviderProps = ComponentProps<typeof Button> & { isPending: boolean; logo?: ReactNode };

export const LoginProviderButton: FC<PropsWithChildren<LoginProviderProps>> = ({
  children,
  isPending,
  logo,
  ...rest
}) => {
  return (
    <Button
      variant="outline"
      size="lg"
      className="group w-full justify-start px-2"
      disabled={isPending}
      {...rest}
    >
      {logo}
      {isPending && <PendingSpinner />}
      <p className="font-bold text-veni-gray-500 group-hover:text-veni-gray-600">{children}</p>
    </Button>
  );
};

const PendingSpinner = () => {
  const t = useTranslations('LoginPage.alts');
  return (
    <>
      <span className="sr-only">{t('loadingText')}</span>
      <Spinner size="extraSmall" className="stroke-veni-gray-500" aria-hidden />
    </>
  );
};
